import { cva } from 'class-variance-authority'

export const iconStyles = cva(
  `
    rounded-md
    text-white
    text-[1.1em]
    h-[26px]
    w-[26px]
    inline-flex
    items-center
    justify-center
    group-hover:bg-black
    transition-colors
    duration-400
    py-1
    bg-danger
    mr-4
  `,
  {
    variants: {
      isCompletedNotReconnectOrOverdue: {
        true: 'bg-green-500',
      },
    },
    defaultVariants: {
      isCompletedNotReconnectOrOverdue: false,
    },
  }
)

export const dateStyles = cva(
  `
    text-right
  `,
  {
    variants: {
      state: {
        completed: 'text-green-500',
        upcoming: 'text-blue-500',
        overdue: 'text-red-500',
        warning: 'text-orange-500',
      },
    },
    defaultVariants: {
      state: 'warning',
    },
  }
)

export const cardStyles = cva(
  `
    group
    hover:bg-white
    hover:outline
    hover:outline-1
    hover:outline-[#1d1d1d]
    cursor-pointer
    border-none
    transition-colors
    duration-400
    hover:shadow-none
    hover:transform-none
  `
)
